import { createSlice } from '@reduxjs/toolkit';

export type FieldType =
  | 'text'
  | 'number'
  | 'date'
  | 'boolean'
  | 'button'
  | 'menu';

interface FieldConfig {
  key: string;
  label: string;
  type: FieldType;
  onHeaderClick?: () => void;
  value: boolean;
}
type ReportMemberRow = {
  memberName: string;
  memberId: string;
  dob: string; // ISO date string
  standingOrder: string;
  contactNumber: string;
  physicalAddress: string;
  mailingAddress: string;
  emailAddress: string;
  memberStatus: string;
  options: any;
};
interface DynamicTableProps {
  columns: FieldConfig[];
  rows: ReportMemberRow[];
  size: number;
  page: number;
}
type ReportReportsDashboardTypes = {
  reportDashboardState: DynamicTableProps;
};

const initialState: ReportReportsDashboardTypes = {
  reportDashboardState: {
    columns: [
      {
        key: 'memberName',
        label: 'Member Name',
        type: 'text',

        value: true,
      },
      { key: 'memberId', label: 'Member ID', type: 'text', value: true },
      { key: 'dob', label: 'Date of Birth', type: 'date', value: true },
      {
        key: 'standingOrder',
        label: 'Standing Order',
        type: 'text',
        value: true,
      },
      {
        key: 'contactNumber',
        label: 'Contact Number',
        type: 'text',
        value: true,
      },
      {
        key: 'physicalAddress',
        label: 'Physical Address',
        type: 'text',
        value: true,
      },
      {
        key: 'mailingAddress',
        label: 'Mailing Address',
        type: 'text',
        value: true,
      },
      {
        key: 'emailAddress',
        label: 'Email Address',
        type: 'text',
        value: true,
      },
      {
        key: 'memberStatus',
        label: 'Status',
        type: 'text',
        value: true,
      },
    ],
    rows: [
      {
        memberName: 'Alice Smith',
        memberId: 'M001',
        dob: '1990-01-01',
        standingOrder: 'Active',
        contactNumber: '1234567890',
        physicalAddress: '123 Main St',
        mailingAddress: 'PO Box 123',
        emailAddress: 'alice@example.com',
        memberStatus: 'Active',
        options: null,
      },
      {
        memberName: 'Bob Johnson',
        memberId: 'M002',
        dob: '1985-05-10',
        standingOrder: 'Inactive',
        contactNumber: '9876543210',
        physicalAddress: '456 Elm St',
        mailingAddress: 'PO Box 456',
        emailAddress: 'bob@example.com',
        memberStatus: 'Inactive',
        options: null,
      },
    ],
    size: 5,
    page: 0,
  },
};

export const reportDashboard = createSlice({
  name: 'reportDashboardTables',
  initialState,
  reducers: {
    toggleColumnVisibility: (state, action) => {
      const { key } = action.payload;
      const columnToToggle = state.reportDashboardState.columns.find(
        (col) => col.key === key
      );
      if (columnToToggle) {
        columnToToggle.value = !columnToToggle.value;
      }
    },
    setReportDashboardData: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {},
});
export const { setReportDashboardData, toggleColumnVisibility } =
  reportDashboard.actions;

export const selectReportDashboardStates = (state) => state.reportDashboard;
export const reportsReducers = reportDashboard.reducer;
